import { memo } from 'react';
import isEqual from 'react-fast-compare';
import UploadArticle from './UploadArticle.jsx';
import { hooks } from '@/store.js';

const UploadCover = memo(
  ({
    id,
    defaultValue,
    className,
  }: {
    id: string;
    defaultValue?: string;
    className?: string;
  }) => {
    const client = hooks.useClient();

    return (
      <UploadArticle
        title='封面'
        defaultValue={
          defaultValue
            ? `https://trip-qiniu.pmlife.top/${defaultValue}?imageView2/2/w/96/h/96`
            : ''
        }
        className={className}
        onDelete={async () => {
          // STEP: 服务器删除
          await (await client.events.get(id).resolved)?.set('cover', '');
        }}
        onSave={async ({ url }) => {
          // STEP: 保存
          await (await client.events.get(id).resolved)?.set('cover', url);
        }}
      />
    );
  },
  isEqual
);

export default UploadCover;
